export function isLastListItem(arr: unknown[], index: number): boolean {
  return index === arr.length - 1;
}
